<template>
  <div class="featured-badges" :class="`featured-badges--${context}`">
    <div
      v-for="(badge, index) in badges"
      :key="`${badge.name}-${index}`"
      class="featured-badges__badge"
    >
      <figure class="featured-badges__figure">
        <img
          v-lazy="imageSize(badge.image, '190x')"
          :alt="badge.name"
          class="featured-badges__image"
        >
      </figure>
    </div>
  </div>
</template>

<script>
import { imageSize } from '@/scripts/helpers/util';

export default {
  name: 'ProductFeaturedBadges',
  props: {
    badges: {
      type: Array,
      default: () => [],
    },
    context: {
      type: String,
      default: 'tile'
    },
  },
  methods: {
    imageSize,
  }
}
</script>

<style lang="scss" scoped>
  .featured-badges {
    position: absolute;
    display: flex;
    flex-direction: column;
  }

  .featured-badges--gallery {
    top: rem(30);
    right: rem(30);
    // width: percentage(100 / 375);
    // max-width: rem(100);
    width: 70px; // To fit for Yieldify badge.
    z-index: 1;

    @include tablet-up {
      top: rem(135);
      right: rem(32);
      // width: percentage(120 / 935);
      // max-width: rem(38);
    }

    @include desktop-up {
      right: rem(185);
      // max-width: rem(120);
      transform: translateX(50%);
    }
  }

  .featured-badges--tile {
    top: rem(32);
    right: rem(8);
    width: percentage(50 / 184);
    z-index: 5;

    @include tablet-up {
      top: rem(50);
      right: rem(14);
      width: percentage(95 / 371);
    }
  }
  
  .featured-badges__badge:not(:last-of-type) {
    margin-bottom: rem(10);
  }

  .featured-badges__figure {
    position: relative;
    padding-bottom: 100%;
  }

  .featured-badges__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
